export default __webpack_public_path__ + "static/media/5.d80af391.mp3";